import { checkHttpStatusAuthCheck } from '../../../../../../../actions/utilAction';
import { actionCreator, defaultPhaseChangeLinesActionsTypes, checkHttpStatus, jsonApiHeader, POST_DEFAULTPHASECHANGELINE_API, showErrorMessage, showSuccessMessage, GET_BEHAVIORREDUCTIONSDATA_API, GET_MASTERDATABYNAME, GET_DEFAULTPHASECHANGELINES_BYPATIENTID, GET_DEFAULTPHASECHANGELINESSETTINGS_BYPATIENTID, GET_TARGETSANDPROGRAMSDATA_API } from '../constants/ApiConstants';


export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_masterData.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function (response) {
        dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_masterData.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('error getMasterData ..', error);
      });
  };
};

export const getPatientBehaviorsReductionByPatientId = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_BehaviorsReductionsData.REQUEST));
    fetch(`${GET_BEHAVIORREDUCTIONSDATA_API}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
    .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function (response) {
        if(response.statusCode === 200)
        dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_BehaviorsReductionsData.SUCCESS, response));
        else 
          dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_BehaviorsReductionsData.SUCCESS, null));
      })
      .catch(function (error) {
        console.log('get master data (soap actions) ..', error);
      });
  };
};

export const getTargetsAndProgramsData = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_TargetsAndProgramsData.REQUEST));
    fetch(`${GET_TARGETSANDPROGRAMSDATA_API}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function (response) {
        if(response.statusCode === 200)
        dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_TargetsAndProgramsData.SUCCESS, response));
        else 
          dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_TargetsAndProgramsData.SUCCESS, null));
      })
      .catch(function (error) {
        console.log('get master data (soap actions) ..', error);
      });
  };
};

export const SaveDefaultPhaseChangeline = (formProps, patientId) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.save_DefaultPhaseChangeline.REQUEST));
      fetch(`${POST_DEFAULTPHASECHANGELINE_API}`, {
          method: 'POST',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
          body: JSON.stringify(formProps),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  showSuccessMessage(response.message);
                  dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.save_DefaultPhaseChangeline.SUCCESS, response));                  
              } else {
                  showErrorMessage(response.message);
                  dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.save_DefaultPhaseChangeline.SUCCESS, null));
              }
          })
          .catch(function (error) {
              console.log('error save_rawbehaviordata', error);
          });
  };
};


// get service code details using api call ...
export const getDefaultPhaseChangelines = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_DefaultPhaseChangelinesByPatientId.REQUEST));
    // let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_DEFAULTPHASECHANGELINES_BYPATIENTID}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_DefaultPhaseChangelinesByPatientId.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error master service code get details ...', error);
      });
  };
};


export const getDefaultPhaseChangelinesSettings = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_DefaultPhaseChangelinesSettingsByPatientId.REQUEST));
    // let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${GET_DEFAULTPHASECHANGELINESSETTINGS_BYPATIENTID}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(defaultPhaseChangeLinesActionsTypes.get_DefaultPhaseChangelinesSettingsByPatientId.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error master service code get details ...', error);
      });
  };
};






// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/defaultPhaseChangeLines/actions/DefaultPhaseChangeLinesActions.js